import React from "react";

import { useNavigate } from "react-router-dom";

import { Button, Typography } from "clearsense-ui/components";
import PageNotFoundIllustration from "images/404/PageNotFound.svg";

import { Home } from "./clearsense-ui/icons";

const PageNotFound = () => {
  const nagivate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center flex-1 w-full h-screen">
      <PageNotFoundIllustration />
      <Typography style="h3" className="mb-3 mt-2.5 font-semibold">
        This page does not exist!
      </Typography>
      <Typography className="max-w-sm text-center">
        Oops! We can’t find the page you requested.
      </Typography>
      <Typography className="max-w-sm mb-6 text-center">
        Please try again.
      </Typography>
      <Button
        style="secondary"
        icon={Home}
        label="Go to Home"
        onClick={() => nagivate("/login")}
      />
    </div>
  );
};

export default PageNotFound;
